import { ProductReviewStars } from '@components/ProductReviewStars/ProductReviewStars'
import { useEffect, useState } from 'react'
import s from './../ProductReviewStars/ReviewRating.module.scss'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'

type YotpoStarsProps = {
    productId: number
    yotoApiKey: string
}

export const YotpoStars = ({ productId, yotoApiKey }: YotpoStarsProps) => {
    const [yotpoReviewDetail, setYotpoReviewDetail] = useState({
        average_score: 0,
        total_reviews: 0
    })
    const { t } = useTranslation('common')

    useEffect(() => {
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }

        fetch(
            `https://api.yotpo.com/products/${yotoApiKey}/${productId}/bottomline`,
            options
        )
            .then((response) => response.json())
            .then(
                (d) =>
                    d?.response?.bottomline &&
                    setYotpoReviewDetail(d.response.bottomline)
            )
    }, [])
    if (!yotpoReviewDetail?.total_reviews) {
        return null
    }
    return (
        <div className={cn(s['reviewRatingMain'], 'review-rating-main')}>
            <ProductReviewStars
                averageScore={yotpoReviewDetail.average_score || 0}
                aria-label={`Product's rating is ${
                    yotpoReviewDetail?.average_score || 0
                } out of 5`}
            />
            <span className="ProductReviewRating-Counter text-size-11 md:text-base">
                {`${yotpoReviewDetail?.total_reviews || 0}  ${t('Review')}${
                    yotpoReviewDetail?.total_reviews > 1 ? 's' : ''
                }`}
            </span>
        </div>
    )
}
